import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { DynamicFieldsService } from '../dynamic-fields.service';
import { SiteConfigService } from '../../../core/services/core.site-config.service';

@Component({
  selector: 'dynfield-text',
  template: require('./dynamic-fields.text.component.html')
})
export class DynamicFieldTextComponent implements OnInit, OnChanges {

  @Input() version: any;
  @Input() field: any;
  @Input() fieldsOptions: any;
  @Input() fieldError: any;
  @Input() allowUpdate: any;

  error: any = {hasError: false, error: ''};
  maxlength: number | string;
  isRequired: boolean;
  trackerCCEnabled: boolean;

  constructor(private dynamicFieldsService: DynamicFieldsService, private siteConfigService: SiteConfigService) {}

  ngOnInit() {
    this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
    this.maxlength = this.dynamicFieldsService.getFieldOptionValue(this.fieldsOptions, this.field, 'attribute2', 255);
    if (this.maxlength === 0) {
      this.maxlength = 255;
    }

    if (this.field.id == 0 && _.isEmpty(this.field.fieldData)) {
      this.field.fieldData = this.dynamicFieldsService.getFieldOptionValue(this.fieldsOptions, this.field, 'defaultValue', '');
    }

    this.isRequired = this.dynamicFieldsService.isRequired(this);

    if (this.field.fieldType == 10) {
      this.maxlength = "";
      if (Number.isInteger(this.field.attribute2) && _.toInteger(this.field.attribute2) > 0) {
        this.maxlength = this.field.attribute2;
      }
    } else {
      this.checkKeyPress = ($event) => {};
    }

    this.trackerCCEnabled = this.siteConfigService.getConfig('trackerCCEnabled', false);
    if (this.field.fieldType == 13) {
      this.allowUpdate = this.allowUpdate && this.trackerCCEnabled;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fieldError) {
      this.error = this.dynamicFieldsService.setError(changes?.fieldError?.currentValue, this.field);
    }
   }

  checkKeyPress($event) {
    if (! /[0-9.,]/.test($event.key)) {
      $event.preventDefault();
    }
  }

  modelChange($event) {
    this.field.fieldData = $event;
    this.error = false;
  }
}
